import React, { useState } from "react";
import "./App.css";   // ✅ THIS WAS MISSING
import Login from "./components/Login";
import Game from "./components/Game";
import Leaderboard from "./components/Leaderboard";

function App() {
  const savedUser = localStorage.getItem("currentUser");
  const [user, setUser] = useState(savedUser);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    setUser(null);
  };

  return (
    <div className="app">
      {user ? (
        <>
          <div className="top-bar">
            <h2>Welcome, {user}</h2>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>

          <Game user={user} />
          <Leaderboard />
        </>
      ) : (
        <Login setUser={setUser} />
      )}
    </div>
  );
}

export default App;
